// src/data/placeCards.js
// プレイスカードのデータを一元管理

const placeCards = [
  {
    id: 1,
    title: "子どもデザインアカデミー\nふくい勝山教室",
    description: "",
    body: "当教室では小中学生のお子様に向けてイラストやマンガの描き方をレッスンしています。お子様のもっと上手くなりたい気持ちに寄り添い、お話を聞きながら楽しく絵を描いています。完全オンライン対応で全国どこに住んでいてもご自宅からご受講いただけます。1〜3人までの少人数制、ご希望に応じて平日日中のレッスンも承ります。無料で3回レッスンを体験いただけます。",
    address: "オンライン教室",
    hours: "月水金土開講",
    contact: "メールフォームよりお問い合わせ下さい",
    detailInfo: {
      location: "オンライン教室",
      phone: "",
      email: "",
      website: {
        name: "げこぽんwebサイト",
        url: "https://www.gekopon.website/art-school/"
      },
      target: "小学生, 中学生, 高校生",
      recommended: "専門的なことを学びたい, オンラインで授業を受けたい, お友達を見つけたい",
      suggestion: "習い事",
      schedule: "水・金・土（それ以外は応相談）",
      fee: "月2回6,000円（税込）〜",
      other: "「マンガやイラストの絵を描くのが好き」というお子様に「人目を気にせず描いていてもいい」時間を提供しています。表現したいこと、やりたいことに合わせて技術や知識もレッスンしております。"
    },
    // 検索用タグ（フィルタリング用）
    searchTags: {
      grade: ["小学生から", "中学生から", "高校生から"],
      situation: ["専門的なことを学びたい", "家以外の場所での居場所を見つけたい", "友達をさがしたい"],
      facility: ["習い事"]
    },
    images: [
      require('../assets/images/AdobeStock_Preview.png'),
    ],
    image: require('../assets/images/AdobeStock_Preview.png'),
    tags: ["小学生", "中学生", "高校生", "習い事"]
  },
  {
    id: 2,
    title: "とまり木",
    description: "",
    body: "福井市で不登校のお子さんを持つお母さん向けに座談会をしています。私自身中学校不登校だった息子の経験から同じような立場で気軽に話せる場が欲しかったことから始めました。少しでも心が軽くなってもらえたら嬉しいです",
    address: "福井市",
    hours: "主に第三か第四日曜日 場所はインスタグラムにて",
    contact: "090-9768-5530",
    detailInfo: {
      location: "福井市",
      phone: "090-9768-5530",
      email: "tomarigi1124@gmail.com",
      website: {
        name: "Instagram（@tomarigi_fukui）",
        url: "https://www.instagram.com/tomarigi_fukui/"
      },
      target: "不登校生の保護者",
      recommended: "不登校や子育てについて相談したい, 不登校や子育てについて共有したい, 同じ悩みを持つ人と話したい",
      suggestion: "不登校児の親のおしゃべり会",
      schedule: "主に第三か第四日曜日 場所はインスタグラムにて",
      fee: "無料",
      other: ""
    },
    // 検索用タグ（フィルタリング用）
    searchTags: {
      grade: ["卒業している場合"],
      situation: ["不登校や子育てについて相談したい", "不登校や子育ての未来について見失わない"],
      facility: ["サークル"]
    },
    images: [
      require('../assets/images/Tomarigi.png'),
    ],
    image: require('../assets/images/Tomarigi.png'),
    tags: ["不登校生の保護者", "不登校児の親のおしゃべり会"]
  },
  {
    id: 3,
    title: "オルタナティブスクール\nちいさな学校ヒトツナガリ",
    description: "",
    body: "ちいさな学校ヒトツナガリは、\n子どもたちが主体性を持って日々の暮らしの中で\n遊び、学ぶ、オルタナティブスクールです。\n\n自然や日々の暮らしの中には、\n生きていく上で大切な多くの学びがあります。\n子どもたちには、遊びの中からでも興味・関心を膨らませ、\n学びを見つける力があります。\n\nちいさな学校ヒトツナガリは、\n暮らしと遊びと学び、すべてがひとつながりとなり、\n子どもたちが伸びやかに自分を表現し\n育っていくことのできる学び場です。",
    address: "福井市",
    hours: "月火木金",
    contact: "0776-65-5623",
    detailInfo: {
      location: "福井市",
      phone: "0776-65-5623",
      email: "hitotsunagari.school@gmail.com",
      website: {
        name: "ちいさな学校ヒトツナガリ",
        url: "https://www.notion.so/236912afa09a80e0a05dc972287eeac9?pvs=4"
      },
      target: "小学生",
      recommended: "専門的なことを学びたい, 家以外の場所での居場所を見つけたい, 外部とコミュニケーションを取れる場所に行きたい, 不登校や子育てについて相談したい, 不登校や子育てについて共有したい, 不登校や子育てのイベントに参加したい, お友達を見つけたい",
      suggestion: "オルタナティブスクール",
      schedule: "月火木金",
      fee: "3000円〜",
      other: "オルタナティブスクールちいさな学校ヒトツナガリでは新入スクール生を随時募集しています◎\n\nヒトツナガリには小学校に行ったことがなく、スクールが私の学校だ！と思って通っている子、\n小学校に週1.2回通いながら、ヒトツナガリに通っている子、\n不登校になって家で過ごしていたけれど、\nヒトツナガリに来るようになった子など\n色んな子がいますよ◎\n\n入学を検討されている方の体験入学も随時受付中！"
    },
    // 検索用タグ（フィルタリング用）
    searchTags: {
      grade: ["小学生から"],
      situation: ["専門的なことを学びたい", "家以外の場所での居場所を見つけたい", "外部とコミュニケーションを取れる場所に行きたい", "不登校や子育てについて相談したい", "不登校や子育てのイベントに参加したい", "友達をさがしたい"],
      facility: ["オルタナティブスクール"]
    },
    images: [
      require('../assets/images/Hitotunagari.png'),
    ],
    image: require('../assets/images/Hitotunagari.png'),
    tags: ["小学生", "オルタナティブスクール"]
  },
  {
    id: 4,
    title: "ミモザの会",
    description: "",
    body: "不登校でお困りの方　お話ししましょ",
    address: "大野市",
    hours: "毎月第一土曜日",
    contact: "090-2837-8050",
    detailInfo: {
      location: "大野市",
      phone: "090-2837-8050",
      email: "z27a227dc278c@i.softbank.jp",
      website: null,
      target: "不登校生の保護者",
      recommended: "不登校や子育てについて相談したい, 不登校や子育てについて共有したい, 同じ悩みを持つ人と話したい",
      suggestion: "親の会",
      schedule: "毎月第一土曜日",
      fee: "無料",
      other: ""
    },
    // 検索用タグ（フィルタリング用）
    searchTags: {
      grade: ["卒業している場合"],
      situation: ["不登校や子育てについて相談したい", "不登校や子育ての未来について見失わない"],
      facility: ["サークル"]
    },
    images: [
      require('../assets/images/AdobeStock_Preview.png'),
    ],
    image: require('../assets/images/AdobeStock_Preview.png'),
    tags: ["不登校生の保護者", "親の会"]
  },
  {
    id: 5,
    title: "中学受験専門個別指導塾\nP!CONT F 福井東教室",
    description: "",
    body: "P!CONT F は県外中学受験まで対応できる個別指導塾です。\n\n県内外の中学受験に向けた勉強はもちろん、普段の勉強のサポートや進路相談も承ります。\n\n不登校を経験していても、受け入れてくれる県外の中学校もあります。幅広い進路選択のサポートをさせていただきます。\n\n通塾以外にも不定期の学習スペース利用も行っております。個別ブースでご自身のペースで過ごすことができます。",
    address: "福井県福井市西方2-11-8",
    hours: "随時",
    contact: "080-1526-3984",
    detailInfo: {
      location: "福井県福井市西方2-11-8",
      phone: "080-1526-3984",
      email: "creperie.in.visby@gmail.com",
      website: {
        name: "P!CONT F 公式サイト",
        url: "https://picont-f.com/"
      },
      target: "小学生, 不登校生の保護者",
      recommended: "専門的なことを学びたい, 一人で学習したい, 家以外の場所での居場所を見つけたい, 外部とコミュニケーションを取れる場所に行きたい",
      suggestion: "塾",
      schedule: "随時",
      fee: "学習スペースは半日1000円、1日1800円です。通塾は別途ご相談ください。",
      other: "学習塾としての事業がメインですが、空き時間を、さまざまなニーズをお持ちの方にご利用いただきたいと思っております。\n\nよろしくお願いいたします。"
    },
    // 検索用タグ（フィルタリング用）
    searchTags: {
      grade: ["小学生から"],
      situation: ["専門的なことを学びたい", "一人で学習したい", "家以外の場所での居場所を見つけたい", "外部とコミュニケーションを取れる場所に行きたい"],
      facility: ["塾"]
    },
    images: [
      require('../assets/images/AdobeStock_Preview.png'),
    ],
    image: require('../assets/images/AdobeStock_Preview.png'),
    tags: ["小学生", "不登校生の保護者", "塾"]
  },
  {
    id: 6,
    title: "福井県\n起立性調節障害 親の会",
    description: "",
    body: "現在、高校から20代前半のお子さんを持つお母さん達が年に何回か集まって色んな悩みや子供達の様子などを話したり情報交換しています。\n　少人数で、みんな困っているお母さん達と繋がりたいなぁと思っています。お気楽に連絡下さい\n　",
    address: "福井県　坂井市",
    hours: "不定期",
    contact: "090-1742-8891",
    detailInfo: {
      location: "福井県　坂井市",
      phone: "090-1742-8891",
      email: "orenji.panda.2015.9@gmail.com",
      website: null,
      target: "小学生, 中学生, 高校生, 不登校生の保護者",
      recommended: "家以外の場所での居場所を見つけたい, 不登校や子育てについて相談したい, 不登校や子育てについて共有したい, お友達を見つけたい, 同じ悩みを持つ人と話したい",
      suggestion: "サークル",
      schedule: "不定期",
      fee: "なし",
      other: ""
    },
    // 検索用タグ（フィルタリング用）
    searchTags: {
      grade: ["小学生から", "中学生から", "高校生から"],
      situation: ["家以外の場所での居場所を見つけたい", "不登校や子育てについて相談したい", "不登校や子育ての未来について見失わない", "友達をさがしたい"],
      facility: ["サークル"]
    },
    images: [
      require('../assets/images/AdobeStock_Preview.png'),
    ],
    image: require('../assets/images/AdobeStock_Preview.png'),
    tags: ["小学生", "中学生", "高校生", "不登校生の保護者", "サークル"]
  },
  {
    id: 7,
    title: "一般社団法人DAISUKI\nごきげん学園",
    description: "",
    body: "ごきげん学園は、1人ひとりの「得意」を伸ばし、自由な発想で学べる新しいスタイルの学び場です。１日２回の授業（自由参加）では、３Dプリンターや農業・AIなど、学校では学べない多彩な学びを取り入れ、自分のペースで成長できる環境を提供します。好きなことに熱中しながら、小さな「できた！」を積み重ね、自信と可能性を広げましょう。",
    address: "福井県福井市米松１丁目15-41　GOKIGENビル１F",
    hours: "平日９時～17時",
    contact: "070-9045-7371",
    detailInfo: {
      location: "福井県福井市米松１丁目15-41　GOKIGENビル１F",
      phone: "070-9045-7371",
      email: "info@daisuki-gokigen.jp",
      website: {
        name: "ごきげん学園公式サイト",
        url: "https://daisuki-gokigen.jp/"
      },
      target: "小学生, 中学生, 不登校生の保護者",
      recommended: "進学したい, 専門的なことを学びたい, 一人で学習したい, 家以外の場所での居場所を見つけたい, 学校行事に参加したい, 外部とコミュニケーションを取れる場所に行きたい, 不登校や子育てについて共有したい, お友達を見つけたい, 同じ悩みを持つ人と話したい, 保護者サポートもしてほしい",
      suggestion: "フリースクール",
      schedule: "平日９時～17時",
      fee: "月額39,800円（税別)／1回利用5000円（税別)",
      other: ""
    },
    // 検索用タグ（フィルタリング用）
    searchTags: {
      grade: ["小学生から", "中学生から"],
      situation: ["進学したい", "専門的なことを学びたい", "一人で学習したい", "家以外の場所での居場所を見つけたい", "学校行事に参加したい", "外部とコミュニケーションを取れる場所に行きたい", "不登校や子育ての未来について見失わない", "友達をさがしたい"],
      facility: ["フリースクール"]
    },
    images: [
      require('../assets/images/AdobeStock_Preview.png'),
    ],
    image: require('../assets/images/AdobeStock_Preview.png'),
    tags: ["小学生", "中学生", "不登校生の保護者", "フリースクール"]
  },
  {
    id: 8,
    title: "ハローインターナショナル",
    description: "",
    body: "自分にあった環境で勉強を続けたい方\n環境を代えて自分の能力を発揮したい方\n様々な選択肢があることをご存知ですか？\nこれまでも海外留学を経て進学し、活躍されているハローの先輩方が何人もおります",
    address: "",
    hours: "",
    contact: "090-3405-7249",
    detailInfo: {
      location: "",
      phone: "090-3405-7249",
      email: "rie@hello-fukui.jp",
      website: {
        name: "ハローインターナショナル公式サイト",
        url: "https://hello-fukui.jp/"
      },
      target: "小学生, 中学生, 高校生",
      recommended: "進学したい, 専門的なことを学びたい, 一人で学習したい, オンラインで授業を受けたい, 家以外の場所での居場所を見つけたい, 外部とコミュニケーションを取れる場所に行きたい, 環境を変えたい（海外留学・進学）",
      suggestion: "塾, オンラインサポート, 習い事, イベント, ",
      schedule: "",
      fee: "留学料金別途お問い合わせ下さい",
      feeUrl: "https://share.google/NJrBZIuQHb4kKDyVQ",
      other: ""
    },
    // 検索用タグ（フィルタリング用）
    searchTags: {
      grade: ["小学生から", "中学生から", "高校生から"],
      situation: ["進学したい", "専門的なことを学びたい", "一人で学習したい", "オンラインで授業を受けたい", "家以外の場所での居場所を見つけたい", "外部とコミュニケーションを取れる場所に行きたい"],
      facility: ["塾", "オンラインサポート", "習い事", "イベント"]
    },
    images: [
      require('../assets/images/AdobeStock_Preview.png'),
    ],
    image: require('../assets/images/AdobeStock_Preview.png'),
    tags: ["小学生", "中学生", "高校生", "塾", "オンラインサポート", "習い事"]
  },
  {
    id: 9,
    title: "ふくいICT中央高等学院",
    description: "",
    body: "当校はみんなの「こうしたい」を尊重しながら、無理なく、楽しく、 高校卒業資格を取得できるようにスタッフが全力でサポートします。どこからでも、やろうと思った時から始められるのが通信制高校です。\n\nふくいICT 中央高等学院は、3年間の間にやりたいことを見つけて、笑顔で巣立っていけるように、 学習面だけでなくパソコンやデジタルスキルを身につけ、「生きる力」を育みます。安心して私たちに任せてください。",
    address: "福井市大宮3丁目6−9",
    hours: "月曜、火曜、水曜、金曜の10時～17時",
    contact: "0776-97-5509",
    detailInfo: {
      location: "福井市大宮3丁目6−9",
      phone: "0776-97-5509",
      email: "irodori@ell-ict.com",
      website: {
        name: "ふくいICT中央高等学院公式サイト",
        url: "https://www.fukui-chuos.com/"
      },
      target: "高校生",
      recommended: "進学したい, 専門的なことを学びたい, 一人で学習したい, 家以外の場所での居場所を見つけたい, 学校行事に参加したい, 外部とコミュニケーションを取れる場所に行きたい, お友達を見つけたい, 同じ悩みを持つ人と話したい",
      suggestion: "通信制サポート校",
      schedule: "月曜、火曜、水曜、金曜の10時～17時",
      fee: "約2万6000円から",
      other: ""
    },
    // 検索用タグ（フィルタリング用）
    searchTags: {
      grade: ["高校生から"],
      situation: ["進学したい", "専門的なことを学びたい", "一人で学習したい", "家以外の場所での居場所を見つけたい", "学校行事に参加したい", "外部とコミュニケーションを取れる場所に行きたい", "友達をさがしたい"],
      facility: ["フリースクール"]
    },
    images: [
      require('../assets/images/AdobeStock_Preview.png'),
    ],
    image: require('../assets/images/AdobeStock_Preview.png'),
    tags: ["高校生", "通信制サポート校"]
  },
  {
    id: 10,
    title: "フリースクールイロドリ",
    description: "",
    body: "不安や悩みがあっても大丈夫！自分のペースに合わせて週1日～3日を選んで、自分のやりたいことを好きな時間にやります。自分が学び直しをしたい学年や教科を選んでの学習、料理やゲームなどの特別活動、デジタルイラストやパソコンなどのICT学習。「高校に行くために勉強のおさらいをしたい」「生活リズムを整えたい」「人と上手に話せるようになりたい」そんな方にぴったりです。まずは入会相談と見学にお越しください。",
    address: "福井市大宮3丁目6-9",
    hours: "月曜、水曜、金曜の10時～16時45分",
    contact: "0776-97-5509",
    detailInfo: {
      location: "福井市大宮3丁目6-9",
      phone: "0776-97-5509",
      email: "irodori@ell-ict.com",
      website: {
        name: "フリースクール イロドリ公式サイト",
        url: "https://www.fukui-chuos.com/chu3-free-school/"
      },
      target: "中学生, 中学3年生が対象です",
      recommended: "進学したい, 家以外の場所での居場所を見つけたい, 学校行事に参加したい, 外部とコミュニケーションを取れる場所に行きたい, お友達を見つけたい, 同じ悩みを持つ人と話したい",
      suggestion: "フリースクール",
      schedule: "月曜、水曜、金曜の10時～16時45分",
      fee: "15,400円～",
      other: ""
    },
    // 検索用タグ（フィルタリング用）
    searchTags: {
      grade: ["中学生から"],
      situation: ["進学したい", "家以外の場所での居場所を見つけたい", "学校行事に参加したい", "外部とコミュニケーションを取れる場所に行きたい", "友達をさがしたい"],
      facility: ["フリースクール"]
    },
    images: [
      require('../assets/images/AdobeStock_Preview.png'),
    ],
    image: require('../assets/images/AdobeStock_Preview.png'),
    tags: ["中学生", "フリースクール"]
  },
  {
    id: 11,
    title: "トーキョーコーヒー福井市",
    description: "",
    body: "私自身、娘が小学生の時に不登校で辛い時期もありました。でも、その中での気づきがとても大きく、今では娘が自分の気持ちを大切にしてくれたこと（不登校）に、感謝するほどです。トーキョーコーヒーは、まずは大人がたのしむことを大切にしています。子どもの側にいる大人がまず自分の在りたい姿で生きていること。そのことが子どもたちにとっても、良き育ちに繋がっていくと信じています。気軽に遊びに来てくださいね。",
    address: "福井市自宅",
    hours: "月2、3回",
    contact: "080-6948-7080",
    detailInfo: {
      location: "福井市自宅",
      phone: "080-6948-7080",
      email: "tokiutukusii55@icloud.com",
      website: {
        name: "Instagram（@tkcf_fukui_363）",
        url: "https://www.instagram.com/tkcf_fukui_363?igsh=MWxxNmFwZnBrNmE3bQ%3D%3D&utm_source=qr"
      },
      target: "不登校生の保護者, 大人も子どももだれでもどうぞ",
      recommended: "外部とコミュニケーションを取れる場所に行きたい, 不登校や子育てについて相談したい, 不登校や子育てについて共有したい, 不登校や子育てのイベントに参加したい, お友達を見つけたい, 同じ悩みを持つ人と話したい",
      suggestion: "大人も子どもも自分らしく在れる場所",
      schedule: "月2、3回",
      fee: "600円+イベントによって",
      other: ""
    },
    // 検索用タグ（フィルタリング用）
    searchTags: {
      grade: [],
      situation: [], 
      facility: []
    },
    images: [
      require('../assets/images/AdobeStock_Preview.png'),
    ],
    image: require('../assets/images/AdobeStock_Preview.png'),
    tags: ["不登校生の保護者", "大人も子どもも自分らしく在れる場所"] // 検索用の簡易タグ
  },
  {
    id: 12,
    title: "うえの未来塾",
    description: "",
    body: "学習の悩み解決します。学校で習えなかったところ基礎から丁寧に教えます。夢の実現のお手伝いをします。安心して任せて下さい。",
    address: "福井市文京2丁目7-18 牧の島メゾンドール204",
    hours: "月　水　木　金　の午後14:00から16:00",
    contact: "080-3045-4353",
    detailInfo: {
      location: "福井市文京2丁目7-18 牧の島メゾンドール204",
      phone: "080-3045-4353",
      email: "uejuku@indigo.plala.or.jp",
      website: null,
      target: "小学生, 中学生, 高校生, 不登校生の保護者",
      recommended: "進学したい, 一人で学習したい, オンラインで授業を受けたい, 家以外の場所での居場所を見つけたい",
      suggestion: "塾",
      schedule: "月　水　木　金　の午後14:00から16:00",
      fee: "一コマ5000円",
      other: "今まで多くの不登校生を指導して大学に合格させて来ました。"
    },
    // 検索用タグ（フィルタリング用）
    searchTags: {
      grade: ["小学生から", "中学生から", "高校生から"],
      situation: ["進学したい", "一人で学習したい", "オンラインで授業を受けたい", "家以外の場所での居場所を見つけたい"],
      facility: ["塾"]
    },
    images: [
      require('../assets/images/AdobeStock_Preview.png'),
    ],
    image: require('../assets/images/AdobeStock_Preview.png'),
    tags: ["小学生", "中学生", "高校生", "不登校生の保護者", "塾"]
  },
  {
    id: 13,
    title: "不登校・ひきこもり\n回復学習会（親の会）",
    description: "",
    body: "中学生、高校生のお子さんのいる親御さんが参加。子の回復につながる子への接し方、親の心構えを楽しく学びます。\n不登校・ひきこもりを経験した当事者の方も参加し、つらかった時、どんな気持ちだったのか、参加者からの質問にも答えてくれます。\n開催日時が変更になる場合があるので、初めて参加されたい方は、事前に加藤まで電話ください。",
    address: "福井県社会福祉センター（福井市光陽）",
    hours: "毎月第１日曜日　13時45分〜16時30分",
    contact: "090-1314-2312",
    detailInfo: {
      location: "福井県社会福祉センター（福井市光陽）",
      phone: "090-1314-2312",
      email: "t.katou.gv@gmail.com",
      website: null,
      target: "不登校生の保護者",
      recommended: "不登校や子育てについて相談したい, 不登校や子育てについて共有したい, 不登校や子育てのイベントに参加したい, 同じ悩みを持つ人と話したい",
      suggestion: "親の会",
      schedule: "毎月第１日曜日　13時45分〜16時30分",
      fee: "1人当たり　500円",
      other: "開催日時が変更になる場合があるので、初めて参加されたい方は、事前に加藤まで電話願います。"
    },
    // 検索用タグ（フィルタリング用）
    searchTags: {
      grade: ["卒業している場合"],
      situation: ["不登校や子育てについて相談したい", "不登校や子育てのイベントに参加したい", "不登校や子育ての未来について見失わない"],
      facility: ["親の会"]
    },
    images: [
      require('../assets/images/AdobeStock_Preview.png'),
    ],
    image: require('../assets/images/AdobeStock_Preview.png'),
    tags: ["不登校生の保護者", "親の会"]
  },
  {
    id: 14,
    title: "子ども若者支援センター\n「坂井子どもの里」",
    description: "",
    body: "一軒家がまるごと活動場所です。安心できる居場所の中で、自分のペースを大切にしながら、好きなことや「やってみたい」を見つけていきましょう。\n学校や支援機関とつながりながら、気持ちや歩みに丁寧に寄り添います。一緒に過ごす時間の中で、少しずつこれからのことを考えていけたらと思います。",
    address: "坂井市坂井町新庄2-325",
    hours: "フリースクール：月～金の９時～１４時　ユースセンター：金土日の１４時～１９時",
    contact: "0776-84-9375",
    detailInfo: {
      location: "坂井市坂井町新庄2-325",
      phone: "0776-84-9375",
      email: "info@fukuinclu.com",
      website: {
        name: "公式サイト",
        url: "https://fukuinclu.com"
      },
      target: "小学生, 中学生, 高校生, 不登校生の保護者",
      recommended: "進学したい, 家以外の場所での居場所を見つけたい, 学校行事に参加したい, 不登校や子育てについて相談したい, 同じ悩みを持つ人と話したい",
      suggestion: "フリースクール, ユースセンター",
      schedule: "フリースクール：月～金の９時～１４時　ユースセンター：金土日の１４時～１９時",
      fee: "行政からの支援をいただいているため、お住まいの地域や家庭状況により異なります",
      other: ""
    },
    // 検索用タグ（フィルタリング用）
    searchTags: {
      grade: ["小学生から", "中学生から", "高校生から"],
      situation: ["進学したい", "家以外の場所での居場所を見つけたい", "学校行事に参加したい", "不登校や子育てについて相談したい", "不登校や子育ての未来について見失わない"],
      facility: ["フリースクール", "ユースセンター"]
    },
    images: [
      require('../assets/images/AdobeStock_Preview.png'),
    ],
    image: require('../assets/images/AdobeStock_Preview.png'),
    tags: ["小学生", "中学生", "高校生", "不登校生の保護者", "フリースクール", "ユースセンター"]
  }
];

export default placeCards;